import { AutogenLayoutOfficePayrollProfileList } from "./autogen/AutogenLayoutOfficePayrollProfileList";
import { Image, TableRowDisplayEvent } from "@mcleod/components";

export class OfficePayrollProfileList extends AutogenLayoutOfficePayrollProfileList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "id", sort: "asc" }];
    }

    tableOfficePayrollProfileListOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();

        const imageProfileColor = tableRow.findComponentById("imageProfileColor") as Image;
        if (imageProfileColor != null) {
            const profileColor = tableRow.data?.getString("profile_color", null);
            imageProfileColor.color = profileColor;
            imageProfileColor.visible = profileColor != null;
        }
    }
}
